import { mapState } from 'vuex';

export default {
    name: 'docInvite',
    props: {
        code : String
    },

    data : function(){

        return {
            loading : false,
            confirmed : false,
            fail : false
        }

    },

    created : function(){
        this.confirm()
    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        confirm : function(){

            if(this.code){
                this.$store.commit('inviteCode', this.code);
                this.loading = true
                this.$root.user.connectToDoc(this.code)
                .then((res) => {

                    this.loading = false

                    if(res.getApp) {
                        this.$router.push('/getApp');
                        return;
                    }

                    if(res.newUser) {
                        this.$router.push('/authorizationwz');
                        return;
                    }

                    this.confirmed = true

                    this.$store.commit('icon', {
                        icon : 'success',
                        message : "You're connected"
                    })

                    this.$router.push('/getApp');

                })
                .catch(() => {
                    this.loading = false
                    this.fail = true

                    this.$router.push('/getApp');

                })

            }

        }
    },
}